import { useAtomValue } from 'jotai'
import { uniqBy } from 'lodash'
import useTokens from 'src/common/apollo/hooks/useTokens'
import { activeTabAtom } from 'src/pages/DiscoverPage/discover-store'
import useManageFilter, { OnFilterChange } from './useManageFilter'
import { AssetOptionKey } from '../OffersFilterDesktop/OffersFilter.desktop'

const useCurrentAssetValues = (onFilterChange: OnFilterChange) => {
  const { erc20s, nfts } = useTokens()

  const activeTab = useAtomValue(activeTabAtom)
  const isMyTab = activeTab === 'my'

  const { filters, updateDepositAssetsFilter, updateWithdrawalAssetsFilter } =
    useManageFilter(onFilterChange)

  const assets = [...erc20s, ...uniqBy(nfts, 'contractAddress')]

  const assetFilterOptions = assets.map(item => ({
    value: item.contractAddress,
    label: item.symbol,
  }))

  const getDepositAssetSelectValue = () => {
    return assetFilterOptions
      .filter(item => filters.depositAssets.includes(item.value))
      .map(item => item.label)
      .join(', ')
  }

  const getWithdrawalAssetSelectValue = () => {
    return assetFilterOptions
      .filter(item => filters.withdrawalAssets.includes(item.value))
      .map(item => item.label)
      .join(', ')
  }

  const currentFilters = {
    sell: isMyTab ? filters.depositAssets : filters.withdrawalAssets,
    buy: isMyTab ? filters.withdrawalAssets : filters.depositAssets,
  }

  const currentFilterHandlers = {
    sell: isMyTab ? updateDepositAssetsFilter : updateWithdrawalAssetsFilter,
    buy: isMyTab ? updateWithdrawalAssetsFilter : updateDepositAssetsFilter,
  }

  const currentRenderedValue = {
    sell: isMyTab
      ? getDepositAssetSelectValue()
      : getWithdrawalAssetSelectValue(),
    buy: isMyTab
      ? getWithdrawalAssetSelectValue()
      : getDepositAssetSelectValue(),
  }

  const currentAssetOptionKey: Record<string, AssetOptionKey> = {
    sell: isMyTab ? 'depositAssets' : 'withdrawalAssets',
    buy: isMyTab ? 'withdrawalAssets' : 'depositAssets',
  }

  return {
    currentFilterHandlers,
    currentRenderedValue,
    currentAssetOptionKey,
    currentFilters,
  }
}

export default useCurrentAssetValues
